import { Injectable } from '@angular/core';
import { LifecycleListenerInterface } from '../../core/interfaces/lifecycle-listener.interface';
import { AuthService } from '@auth0/auth0-angular';
import { take } from 'rxjs/operators';

declare global {
  interface Window {
    _hsq: any;
  }
}

@Injectable()
export class HubspotLifecycleListener implements LifecycleListenerInterface {
  constructor(private readonly authService: AuthService) {
  }

  async onFirstLoad(): Promise<void> {
    this.authService.user$.pipe(take(1)).subscribe(user => {
      const _hsq = window._hsq = window._hsq || [];

      if (!user) {
        return;
      }

      _hsq.push(['identify', {
        email: user.email,
        firstName: user.name,
        lastName: user.given_name,
      }]);
      console.debug('Set Hubspot user:', user);
    });
  }
}